export default __webpack_public_path__ + "static/media/onboardingBg2.285ed153.png";